import { memo } from 'react';
import { ui } from '@procuros/datachecks';

import { DisplayModes } from 'services/webedi/types';
import { cn } from 'support/helpers/cn/cn';
import { WebEDISection } from 'components/WebEDI/WebEDISection/WebEDISection';

import { SchemableForm } from '../../SchemableForm/SchemableForm';
import { DocumentSectionAnnotation } from '../DocumentSectionAnnotation/DocumentSectionAnnotation';

export const DocumentHeaderInfo = memo(
  ({ config, mode, isSubmitting }: { config: ui.InfoSection; mode: DisplayModes; isSubmitting: boolean }) => {
    if (!config.fields?.length) {
      return null;
    }

    return (
      <WebEDISection
        header={config.label ? { title: config.label, description: config.description, spacing: 'medium' } : undefined}
      >
        <div className="@container space-y-4">
          <DocumentSectionAnnotation path="info" sectionConfig={config} />
          <div className={cn('grid grid-cols-2 gap-4 @[640px]:grid-cols-3 @[900px]:grid-cols-4')}>
            <SchemableForm dataPathPrefix="info.0" config={config} mode={mode} isSubmitting={isSubmitting} />
          </div>
        </div>
      </WebEDISection>
    );
  },
);

DocumentHeaderInfo.displayName = 'DocumentHeaderInfo';
